import React from 'react';
import PropTypes from 'prop-types';
import './CoachProfileTile.scss';
import { useHistory } from 'react-router-dom';

const CoachProfileTile = ({ user_id, profile_pic_thumb, first_name, last_name, show_last_name, ...props }) => {

    const history = useHistory();

    return (
        <div className="CoachProfileTile" onClick={() => history.push(`/CoachProfile/${user_id}`)} >
            <div className="CoachImageDiv">
                <img src={profile_pic_thumb} alt={''} />
            </div>
            <p className="CoachName">{first_name} {show_last_name ? last_name : null}</p>
        </div>
    )

}

export default CoachProfileTile;

CoachProfileTile.propTypes = {
    show_last_name: PropTypes.bool
}

CoachProfileTile.defaultProps = {
    show_last_name: false
}